import React, { useState, useEffect, useCallback } from 'react';

// ============================================================================
// YAYINEVİ SEÇİCİ (2026-09-15, kullanıcı kararı: "yayınevleri DB listesi; her
// yayınevi girişi tek ortak seçici"). Serbest metin yayınevi KAYDI yoktur —
// her yer bu bileşenle listeden seçer; olmayan yayınevi "+ Yeni" ile satır içi
// eklenir (POST /api/yayinevi) ve hemen seçilir.
//
// Kullananlar: SatisEkleModal (zorunlu), Basım Çıktı bölümü (teslim açıkken
// zorunlu), Satış Arşivi filtresi (Tümü + pasifler dahil, ekleme yok),
// YayineviListesi'nin karşısında değil — o kendi listesini yönetir.
//
// Sözleşme:
//   GET  /api/yayinevi[?aktif=1] → { basarili, yayinevleri:[{id, ad, aktif, ...}] }
//   POST /api/yayinevi {ad}       → { basarili, yayinevi:{id, ad, aktif}, mevcut }
//        mevcut:true → aynı ad (normalize) zaten kayıtlıydı; o satır seçilir.
//   onChange({id, ad}) | onChange(null)
// Enter / Escape ekleme kutusunda ÜST FORMU tetiklemez (preventDefault +
// stopPropagation) — aksi hâlde SatisEkleModal "Satışı Kaydet"i gönderirdi.
// ============================================================================
const girdiSinifi = 'px-2 py-1.5 border border-gray-300 rounded text-xs bg-white';

// kaynak="okul" (2026-10-08, okul kapağı): aynı seçici /api/okul listesini okur/ekler;
// yanıt anahtarları ve data-* öznitelikleri kaynağa göre (yayınevi testleri aynen).
const KAYNAKLAR = {
  yayinevi: { yol: 'yayinevi', liste: 'yayinevleri', tekil: 'yayinevi', ad: 'Yayınevi', adKucuk: 'yayınevi' },
  okul: { yol: 'okul', liste: 'okullar', tekil: 'okul', ad: 'Okul', adKucuk: 'okul' },
};

export default function YayineviSecici({
  apiUrl, authFetch, value = null, valueAd = '', onChange,
  zorunlu = false, etiket = 'Yayınevi', bosSecenek = 'Yayınevi seçin…',
  allowInactive = false, yeniEkle = true, autoFocus = false, className = '', kaynak = 'yayinevi',
}) {
  const K = KAYNAKLAR[kaynak] || KAYNAKLAR.yayinevi;
  const d = (ek) => ({ [`data-${K.yol}-${ek}`]: true });
  const [liste, setListe] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [listeHata, setListeHata] = useState('');
  const [yenileSayaci, setYenileSayaci] = useState(0);
  const [ekleAcik, setEkleAcik] = useState(false);
  const [yeniAd, setYeniAd] = useState('');
  const [ekleniyor, setEkleniyor] = useState(false);
  const [ekleHata, setEkleHata] = useState('');
  const [bilgi, setBilgi] = useState('');

  useEffect(() => {
    let iptal = false;
    setYukleniyor(true); setListeHata('');
    authFetch(`${apiUrl}/api/${K.yol}${allowInactive ? '' : '?aktif=1'}`)
      .then((r) => r.json().catch(() => ({})).then((d) => ({ r, d })))
      .then(({ r, d }) => {
        if (iptal) return;
        if (!r.ok || !d || !d.basarili || !Array.isArray(d[K.liste])) {
          throw new Error((d && d.hata) || `${K.ad} listesi alınamadı`);
        }
        setListe(d[K.liste]);
        setYukleniyor(false);
      })
      .catch((e) => {
        if (iptal) return;
        setListe([]);
        setListeHata(e.message || `${K.ad} listesi alınamadı`);
        setYukleniyor(false);
      });
    return () => { iptal = true; };
  }, [apiUrl, authFetch, allowInactive, yenileSayaci, K]);

  const secimDegisti = (e) => {
    const v = e.target.value;
    setBilgi('');
    if (!v) { if (onChange) onChange(null); return; }
    const id = Number(v);
    const satir = liste.find((y) => Number(y.id) === id);
    const ad = satir ? satir.ad : (Number(value) === id ? (valueAd || '') : '');
    if (onChange) onChange(satir && satir.logo_var !== undefined ? { id, ad, logo_var: satir.logo_var } : { id, ad });
  };

  const ekle = useCallback(async () => {
    const ad = yeniAd.trim();
    if (!ad) { setEkleHata(`${K.ad} adı boş olamaz`); return; }
    setEkleniyor(true); setEkleHata(''); setBilgi('');
    try {
      const r = await authFetch(`${apiUrl}/api/${K.yol}`, { method: 'POST', body: JSON.stringify({ ad }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d || !d.basarili || !d[K.tekil]) {
        setEkleHata((d && d.hata) || `${K.ad} eklenemedi`);
        setEkleniyor(false);
        return;
      }
      const y = d[K.tekil];
      setListe((p) => (p.some((x) => Number(x.id) === Number(y.id))
        ? p.map((x) => (Number(x.id) === Number(y.id) ? { ...x, ...y } : x))
        : [...p, y]));
      if (d.mevcut) setBilgi(`“${y.ad}” zaten kayıtlıydı — seçildi.`);
      if (onChange) onChange(y.logo_var !== undefined ? { id: Number(y.id), ad: y.ad, logo_var: y.logo_var } : { id: Number(y.id), ad: y.ad });
      setEkleAcik(false); setYeniAd(''); setEkleniyor(false);
    } catch (e) {
      setEkleHata(`${K.ad} eklenemedi: ` + e.message);
      setEkleniyor(false);
    }
  }, [apiUrl, authFetch, yeniAd, onChange, K]);

  const vazgec = () => { setEkleAcik(false); setYeniAd(''); setEkleHata(''); };
  const tusla = (e) => {
    if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); ekle(); }
    else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); vazgec(); }
  };

  const secili = value == null || value === '' ? '' : String(value);
  const listede = secili !== '' && liste.some((y) => String(y.id) === secili);

  return (
    <div className={`inline-flex flex-col gap-1 ${className}`} {...d('secici-kutu')}>
      {etiket ? <label className="block text-[10px] font-semibold text-gray-500">{etiket}</label> : null}
      <div className="flex flex-wrap items-center gap-1.5">
        <select {...d('secici')} value={secili} onChange={secimDegisti} required={zorunlu}
          autoFocus={autoFocus && !ekleAcik}
          aria-label={etiket || K.ad} className={`${girdiSinifi} min-w-[9rem]`}>
          <option value="">{yukleniyor ? 'Yükleniyor…' : bosSecenek}</option>
          {!listede && secili !== '' && (
            <option value={secili}>{valueAd || `#${secili}`}</option>
          )}
          {liste.map((y) => (
            <option key={y.id} value={String(y.id)}>
              {y.ad}{y.aktif === false ? ' (pasif)' : ''}
            </option>
          ))}
        </select>
        {yeniEkle && !ekleAcik && (
          <button type="button" onClick={() => { setEkleAcik(true); setEkleHata(''); setBilgi(''); }}
            title={`Listede olmayan ${K.adKucuk} kaydını ekle ve seç`}
            className="px-2 py-1.5 rounded border border-emerald-300 bg-emerald-50 text-emerald-800 text-xs font-semibold hover:bg-emerald-100">
            + Yeni
          </button>
        )}
        {yeniEkle && ekleAcik && (
          <>
            <input {...d('yeni')} type="text" value={yeniAd} onChange={(e) => { setYeniAd(e.target.value); setEkleHata(''); }}
              onKeyDown={tusla} placeholder={`Yeni ${K.adKucuk} adı`} maxLength={120} autoFocus
              className={`${girdiSinifi} w-44`} />
            <button type="button" onClick={ekle} disabled={ekleniyor}
              className="px-2 py-1.5 rounded bg-emerald-600 text-white text-xs font-semibold hover:bg-emerald-700 disabled:opacity-40">
              {ekleniyor ? 'Ekleniyor…' : 'Ekle'}
            </button>
            <button type="button" onClick={vazgec} disabled={ekleniyor}
              className="px-2 py-1.5 rounded border border-gray-300 text-xs hover:bg-gray-50 disabled:opacity-40">
              Vazgeç
            </button>
          </>
        )}
      </div>
      {listeHata && (
        <div {...d('liste-hata')} className="text-[11px] text-red-600 font-semibold flex items-center gap-1.5">
          <span>{listeHata}</span>
          <button type="button" onClick={() => setYenileSayaci((n) => n + 1)}
            className="underline text-red-700 hover:text-red-900">Yeniden dene</button>
        </div>
      )}
      {ekleHata && <div {...d('ekle-hata')} className="text-[11px] text-red-600 font-semibold">{ekleHata}</div>}
      {bilgi && <div {...d('bilgi')} className="text-[11px] text-emerald-700">{bilgi}</div>}
    </div>
  );
}
